import React from 'react';

import Modal from '@tv2/lib-offspring/components/messages/Modal';
import { LeftArrowWhiteNext } from '@tv2/ui-system/icons/next/navigation/LeftArrowWhiteNext';
import { MotorButton } from '@tv2/ui-system/components/MotorButton';
import { Prompt } from '../usePrompt';

type Props = {
  prompt: Prompt;
  backToPrompt: () => void;
};

export function ExtendedText({
  prompt: {
    data: { layout: prompt, colorTheme },
  },
  backToPrompt,
}: Props) {
  const theme =
    colorTheme === 'Dark'
      ? 'theme-dark text-white bg-midnight-900'
      : 'theme-ligth text-midnight bg-white';

  return (
    <Modal noDismiss>
      <div
        className={`relative flex flex-col my-0 mx-auto w-full w-max-[590px] w-max-[min(93vw, 590px)] ${theme}`}
      >
        <div className="flex flex-row pt-shared-spacing-dynamic-l px-shared-spacing-dynamic-l">
          <MotorButton
            darkMode={colorTheme === 'Dark'}
            color="secondary"
            size="medium"
            icon={LeftArrowWhiteNext}
            onClick={backToPrompt}
          >
            Tilbage
          </MotorButton>
        </div>
        <div className="pt-6 pb-10 px-shared-spacing-dynamic-l ">
          <h3 className="text-heading-l pb-5">{prompt.extendedInfo?.title}</h3>
          <div
            className="text-body-s link-inline"
            dangerouslySetInnerHTML={{ __html: prompt.extendedInfo!.text }}
          />
        </div>
      </div>
    </Modal>
  );
}
